import {Card, CardContent, CardHeader, Stack, Typography} from "@mui/material";
import {LocalShipping, People} from "@mui/icons-material";
import Constants from "../../../../utils/constants.js";
import {EngineOnIcon} from "../../../../utils/ui/Icons/EngineOnIcon.js";
import {EngineOffIcon} from "../../../../utils/ui/Icons/EngineOff.js";
import {helper} from "../../../../utils/helper.js";

function LaveuseCard({laveuse, selectedDate}) {

    const getLaveuseIconColor = () => {
        const problems = laveuse?.problems ?? [];
        if (problems.length === 0) return Constants.COLOR_THEME_GREEN;

        let severity = Math.max(...problems.map(p => p.importance));
        return severity ? helper.getLaveuseImportanceColor(severity) : Constants.COLOR_THEME_GREEN;
    }

    const getEngineTimeLabel = (ignitionType) => {
        const value = ignitionType === "on"
            ? laveuse?.engineTimes?.ignition_on
            : laveuse?.engineTimes?.ignition_off;
        return value ?? "-";
    }

    const getKilometers = () => {
        if (laveuse.kilometrageDebut && laveuse.kilometrageFin) {
            return (laveuse.kilometrageFin - laveuse.kilometrageDebut) + " Km";
        }
        return "- Km";
    }

    return (
        <Card sx={{border: `1px solid ${getLaveuseIconColor()}`, minWidth: "300px"}}>
            <CardHeader
                title={
                    <Stack direction="row" spacing={2} justifyContent="space-between">
                        <Stack direction="row" spacing={1} alignItems="center">
                            <LocalShipping sx={{fontSize: "24px", color: getLaveuseIconColor()}}/>
                            <Typography variant="body1">{laveuse.description}</Typography>
                        </Stack>
                        <Stack direction="row" spacing={1} alignItems="center">
                            <People sx={{color: Constants.COLOR_THEME_GREEN}}/>
                            <Typography variant="body1">{laveuse.operateur}</Typography>
                        </Stack>
                    </Stack>
                }
            />
            <CardContent sx={{padding: "0 .25rem 0", paddingBottom: "0.25rem !important"}}>
                <Stack direction="row" justifyContent="space-between" alignItems="center">
                    <Stack direction="row" spacing={2} alignItems="center">
                        <EngineOnIcon style={{fontSize: "24px"}}/>
                        <Typography variant="body2">{getEngineTimeLabel("on")}</Typography>
                    </Stack>

                    <Stack direction="column" sx={{flexGrow: 1}}>
                        <div className="line"></div>
                        <Typography variant="body2" textAlign="center">{getKilometers()}</Typography>
                    </Stack>

                    <Stack direction="row" spacing={2} alignItems="center">
                        <Typography variant="body2">{getEngineTimeLabel("off")}</Typography>
                        <EngineOffIcon style={{fontSize: "24px"}}/>
                    </Stack>
                </Stack>
            </CardContent>
        </Card>
    );
}

export default LaveuseCard;
